import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Grid from '@mui/material/Grid2'
import {
  Button,
  Box,
  Typography,
  FormControl,
  TextField,
  Avatar,
  MenuItem,
  InputLabel,
  Select,
  Stack,
  Autocomplete,
  Divider,
} from '@mui/material'

import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined'
import Ellipse1 from '../../../asset/Ellipse1.png'
import Ellipse2 from '../../../asset/Ellipse2.png'
import GirlAndBoy from '../../../asset/GirlAndBoy.png'
import { borderRadius, styled } from '@mui/system'
import Api from '../../../Api/Api'
import { TreeSelect } from 'antd'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import back_arrow from '../../../asset/back_arrow.png'

const Title = (props) => {
  // console.log('render')
  return <Typography>{props.title}</Typography>
}

const styles1 = {
  Typography1: {
    color: '#ffffff',
    display: 'flex',
    justifyContent: 'flex-start',
    justifyItems: 'flex-start',
    mt: 3,
  },
  InputTextField1: {
    width: '100%',
    height: 54,
    '.MuiOutlinedInput-notchedOutline': {
      borderRadius: '11px',
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
  },
  Select1: {
    '& label': {
      color: '#e4e4e7',
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      opacity: 0.8,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },
    '& .MuiSvgIcon-root': {
      color: '#ffffff',
    },
    '& .MuiInputBase-input': {
      color: '#ffffff',
    },
    '&:hover .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
      opacity: 0.8,
    },
    '&.Mui-focused .MuiInputBase-input': {
      borderColor: '#afafaf',
      borderWidth: '1px',
    },

    color: '#ffffff',
    backdropFilter: 'blur(53px)',
    boxShadow: '-8px 4px 5px 0px #0000003d',
    borderRadius: 2,
    background: '#171821',
    // border: '1px solid #afafaf',
    // borderImageSource:
    //   'linear-gradient(166.93deg, #afafaf 3.24%, rgba(96, 96, 96, 0) 96.43%),linear-gradient(317.92deg, rgba(255, 255, 255, 0.6) 1.48%, rgba(0, 0, 0, 0) 37.95%)',
  },
}
const InputTextField = styled(TextField)({
  '& label': {
    // placeholder text color
    color: '#BCBDC4',
  },
  '& label.Mui-focused': {
    // 해당 input focus 되었을 때 placeholder text color
    // floatng label을 사용할 때 처리 필요하다
    color: '#BCBDC4',
  },

  '& label.Mui-error': {
    color: '#d32f2f',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: '#ffffff',
    borderWidth: '0.15rem',
  },
  '& .MuiOutlinedInput-root': {
    color: '#ffffff',
    '& fieldset': {
      borderColor: '#BCBDC4',
    },
  },
  '&:hover .MuiInputBase-input': {
    borderColor: '#afafaf',
    borderWidth: '1px',
    opacity: 0.8,
  },
  '&.Mui-focused .MuiInputBase-input': {
    borderColor: '#afafaf',
    borderWidth: '1px',
  },
})

const testList = [
  { title: 'The Shawshank Redemption', year: 1994 },
  { title: 'The Godfather', year: 1972 },
  { title: 'The Godfather: Part II', year: 1974 },
  { title: 'The Dark Knight', year: 2008 },
  { title: '12 Angry Men', year: 1957 },
]

export default function RegisterPage() {
  const pattern_num = /[0-9]/ // 숫자
  const pattern_eng = /[a-zA-Z]/ // 문자
  const pattern_spc = /[~!@#$%^&*()_+|<>?:{}]/ // 특수문자
  const pattern_kor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/ // 한글체크

  //유효성검사 특수문자 한글
  const validation = (param) => {
    let check = /[~!@#$%^&*()+|<>?:{}.,/;='"ㄱ-ㅎ | ㅏ-ㅣ |가-힣]/
    return check.test(param)
  }

  const [OrgData, setOrgData] = useState([])
  const [userList, setUserList] = useState([])
  const [inputUid, setInputUid] = useState('')
  const [errorInputUid, setErrorInputUid] = useState(false)
  const [inputPw, setInputPw] = useState('')
  const [errorInputPw, setErrorInputPw] = useState(false)
  const [inputCheckPw, setInputCheckPw] = useState('')
  const [errorInputCheckPw, setErrorInputCheckPw] = useState(false)

  const [inputPh, setInputPh] = useState('')
  const [inputMl, setInputMl] = useState('')
  const [errorInputMl, setErrorInputMl] = useState(false)

  const [inputOrgid, setInputOrgid] = useState('')
  const [inputPuid, setInputPuid] = useState('')

  const navigate = useNavigate()

  const onClickBack = () => {
    navigate(-1)
  }
  useEffect(() => {
    Org()
    Users()
  }, [])

  const handleInputUid = (e) => {
    const value = e.target.value
    if (validation(value)) {
      alert('한글이나 특수문자는 입력 할 수 없습니다.')
    }
    const values = e.target.value.replace(/\s+/g, '')
    const result = values.replace(/[^A-Za-z0-9_]/gi, '')
    setInputUid(result)
    if (result.length >= 5 && result.length <= 12) {
      setErrorInputUid(false)
    } else {
      setErrorInputUid(true)
    }
  }

  const handleInputMl = (e) => {
    const value = e.target.value
    validateEmail(value)
    setInputMl(value)
    if (validateEmail(value)) {
      setErrorInputMl(false)
    } else {
      setErrorInputMl(true)
    }
  }

  const handleInputPwChange = (e) => {
    const value = e.target.value

    setInputPw(value)
    if (value.length >= 9 && value.length <= 20) {
      setErrorInputPw(false)
    } else {
      setErrorInputPw(true)
    }
  }

  const handleInputCheckPwChange = (e) => {
    const value = e.target.value
    setInputCheckPw(value)
    if (value === inputPw) {
      setErrorInputCheckPw(false)
    } else {
      setErrorInputCheckPw(true)
    }
  }

  //email 유효성 체크1
  const validateEmail = (email) => {
    return email.match(
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
  }

  const Users = async () => {
    try {
      const response = await Api.get('/api/v1/users')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setUserList(response.data)
      }
      // console.log('response.data Users', response.data)
    } catch (e) {
      console.log('Users exception', e)
    }
  }

  const Org = async () => {
    try {
      const response = await Api.get('/api/v1/orgn')
      // const response = await Api.get('/api/v1/orgn', {
      //   withCredentials: true,
      // })
      if (response.status === 200) {
        setOrgData(response.data)
      }
      // console.log('response.data', response.data)
    } catch (e) {
      console.log('Org exception', e)
    }
  }
  function nullCheck(param) {
    if (param === undefined || param === null || param === '') {
      return true
    } else {
      return false
    }
  }

  const registerUser = async (e) => {
    let validationValue = true
    e.preventDefault()
    const userObject = {
      uid: inputUid,
      pw: inputPw,
      ph: inputPh,
      ml: inputMl,
      orgid: inputOrgid,
      puid: inputPuid,
    }
    for (let i of Object.values(userObject)) {
      if (nullCheck(i)) {
        validationValue = false
      }
    }
    // console.log('userObject:', userObject)
    if (
      validationValue === true &&
      errorInputCheckPw === false &&
      errorInputPw === false &&
      errorInputMl === false &&
      errorInputUid === false
    ) {
      try {
        const response = await Api.post('/api/v1/users', userObject)
        // const response = await Api.get('/api/v1/orgn', {
        //   withCredentials: true,
        // })
        if (inputPw === inputCheckPw) {
          if (response.status === 200) {
            setInputUid('')
            setInputPw('')
            setInputCheckPw('')
            setInputPh('')
            setInputMl('')
            setInputOrgid('')
            setInputPuid('')
            alert('사용자가 등록 되었습니다')
          }
          if (response.status !== 200) {
            alert('사용자가 등록이 되지 않았습니다')
          }
        } else {
          alert('비밀번호 입력란과 비밀번호 확인란이 일치하지 않습니다.')
        }

        // console.log('response.data', response.data)
      } catch (e) {
        alert('사용자가 등록이 되지 않았습니다. 사용자가 있거나 잘못된 요청입니다.')
        console.log('registerUser exception', e)
      }
    } else {
      alert('빈칸이 있거나 입력란에 대한 유효성 검증이 통과되지 않았습니다.')
    }
  }

  return (
    <div>
      <Grid container>
        <Grid size={12} sx={{ marginLeft: 5, display: 'flex', justifyContent: 'flex-start' }}>
          <Button onClick={() => onClickBack()}>
            <img src={back_arrow} style={{ width: 51, height: 51 }}></img>
            {/* <ArrowBackIosNewOutlinedIcon sx={{ width: 51, height: 51, color: '#A2A2A8' }} /> */}
          </Button>
        </Grid>
        <Grid size={12}>
          <Grid container>
            <Grid
              size={2}
              sx={{
                marginTop: 10,
                marginRight: 3,
                display: 'flex',
                alignContent: 'flex-end',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                justifyItems: 'flex-end',
              }}
            >
              <div>
                <img style={{}} src={GirlAndBoy}></img>
              </div>
            </Grid>
            <Grid size={8} sx={{ marginTop: 10 }}>
              <div>
                <img style={{ marginBottom: -90, display: 'flex' }} src={Ellipse1}></img>
                <Box
                  sx={{
                    marginLeft: 3,
                    marginRight: 3,
                    backdropFilter: 'blur(53px)',
                    boxShadow: '-8px 4px 5px 0px #0000003d',
                    borderRadius: '10px',
                    border: '1px solid #AFAFAF',
                    background:
                      'linear-gradient(0deg, rgba(0, 0, 0, 0.14), rgba(0, 0, 0, 0.14)),linear-gradient(321.23deg, rgba(191, 191, 191, 0.062) 5.98%, rgba(0, 0, 0, 0) 66.28%)',
                  }}
                >
                  <Box sx={{ margin: 5 }}>
                    <Typography
                      sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        fontFamily: 'Noto Sans',
                        fontSize: '36px',
                        fontWeight: 600,
                        lineHeight: '49.03px',
                        textAlign: 'left',
                        textUnderlinePosition: 'from-font',
                        textDecorationSkipInk: 'none',
                        color: '#FFFFFF',
                      }}
                    >
                      사용자등록
                    </Typography>
                    <Typography
                      sx={{
                        marginTop: 0.5,
                        display: 'flex',
                        justifyContent: 'center',
                        fontFamily: 'Noto Sans',
                        fontSize: '15px',
                        fontWeight: 500,
                        lineHeight: '21.79px',
                        textAlign: 'left',
                        textUnderlinePosition: 'from-font',
                        textDecorationSkipInk: 'none',
                        color: '#FFFFFF',
                      }}
                    >
                      사용자 등록 정보를 입력해주세요
                    </Typography>
                    <Grid container spacing={8}>
                      <Grid size={6}>
                        <Stack>
                          <Typography sx={styles1.Typography1}>아이디*</Typography>{' '}
                          <InputTextField
                            placeholder="아이디"
                            variant="outlined"
                            value={inputUid}
                            error={errorInputUid}
                            helperText={errorInputUid ? '아이디의 길이가 맞지 않습니다.(5-12자리)' : ''}
                            onChange={handleInputUid}
                            sx={styles1.InputTextField1}
                          />
                        </Stack>
                        <Stack>
                          <Typography sx={styles1.Typography1}>비밀번호*</Typography>{' '}
                          <InputTextField
                            value={inputPw}
                            type="password"
                            placeholder="비밀번호"
                            variant="outlined"
                            error={errorInputPw}
                            helperText={errorInputPw ? '비밀번호가 길이가 맞지 않습니다.(9-20자리)' : ''}
                            onChange={handleInputPwChange}
                            sx={styles1.InputTextField1}
                          />
                        </Stack>
                        <Stack>
                          <Typography sx={styles1.Typography1}>비밀번호 확인*</Typography>{' '}
                          <InputTextField
                            value={inputCheckPw}
                            type="password"
                            placeholder="비밀번호 확인"
                            variant="outlined"
                            onChange={handleInputCheckPwChange}
                            error={errorInputCheckPw}
                            helperText={errorInputCheckPw ? '비밀번호가 일치하지 않습니다.' : ''}
                            sx={styles1.InputTextField1}
                          />
                        </Stack>
                        <Stack>
                          <Typography sx={styles1.Typography1}>이메일*</Typography>{' '}
                          <InputTextField
                            value={inputMl}
                            placeholder="이메일"
                            variant="outlined"
                            error={errorInputMl}
                            helperText={errorInputMl ? '이메일 형식이 맞지 않습니다.' : ''}
                            onChange={handleInputMl}
                            sx={styles1.InputTextField1}
                          />
                        </Stack>
                      </Grid>
                      <Grid size={6}>
                        <Stack>
                          <Typography sx={styles1.Typography1}>전화번호</Typography>{' '}
                          <InputTextField
                            value={inputPh}
                            placeholder="전화번호"
                            variant="outlined"
                            onChange={(e) => setInputPh(e.target.value)}
                            sx={styles1.InputTextField1}
                          />
                        </Stack>
                        <Stack sx={{ marginTop: 0 }}>
                          <Typography sx={styles1.Typography1}>소속*</Typography>{' '}
                          <TreeSelect
                            className="treeSelect"
                            value={inputOrgid}
                            suffixIcon={<ArrowDropDownIcon />}
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            treeData={OrgData}
                            treeTitleRender={(item) => {
                              return <Title title={item.orgn} />
                            }}
                            fieldNames={{ labal: 'orgid', key: 'orgid', value: 'orgid' }}
                            placeholder="부서 선택"
                            treeDefaultExpandAll
                            onChange={(e) => setInputOrgid(e)}
                          />
                        </Stack>
                        <Stack sx={{ marginTop: 2.8 }}>
                          <Typography sx={styles1.Typography1}>상위관리자*</Typography>{' '}
                          <FormControl fullWidth>
                            <Select
                              displayEmpty
                              value={inputPuid}
                              onChange={(e) => setInputPuid(e.target.value)}
                              sx={[styles1.Select1]}
                            >
                              {userList.map((item, index) => {
                                return <MenuItem key={index} value={item.uid}>{`${item.uid}`}</MenuItem>
                              })}
                            </Select>
                          </FormControl>
                        </Stack>
                      </Grid>
                    </Grid>
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <Button
                        variant="contained"
                        sx={{
                          borderRadius: '12px',
                          marginTop: 8,
                          width: '48%',
                          fontSize: '20px',
                          background: 'linear-gradient(89.58deg, #628EFF 10%, #8740CD 57.32%, #580475 99.08%);',
                          fontFamily: 'Noto Sans',
                          fontWeight: 600,
                          lineHeight: '27.24px',
                        }}
                        onClick={registerUser}
                      >
                        계정 등록
                      </Button>
                    </Box>
                  </Box>
                </Box>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <img style={{ marginTop: -50 }} src={Ellipse2}></img>
                </div>
              </div>
            </Grid>
            <Grid size={2} sx={{ marginTop: 10, display: 'flex', alignContent: 'flex-end' }}></Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}
